export default __webpack_public_path__ + "static/media/folder-add.9b4609e3.svg";